import {formatDate} from "element-ui/src/utils/date-util";

Date.prototype.Format = function (fmt) {
    var o = {
        "M+": this.getMonth() + 1, //月份
        "d+": this.getDate(), //日
        "h+": this.getHours(), //小时
        "m+": this.getMinutes(), //分
        "s+": this.getSeconds(), //秒
        "q+": Math.floor((this.getMonth() + 3) / 3), //季度
        "S": this.getMilliseconds() //毫秒
    };
    if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (var k in o)
        if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    return fmt;
}

export default class DateUtils {

    static stringToDate(dateStr, separator) {
        if (!separator) {
            separator = "-";
        }
        let dateArr = dateStr.split(separator);
        let year = parseInt(dateArr[0]);
        let month;
        if (dateArr[1].indexOf("0") == 0) {
            month = parseInt(dateArr[1].substring(1));
        } else {
            month = parseInt(dateArr[1]);
        }
        let day = parseInt(dateArr[2]);
        let date = new Date(year, month - 1, day);
        return date;
    }

    static getDaysBetween(dateString1, dateString2) {
        let startDate = Date.parse(dateString1);
        let endDate = Date.parse(dateString2);
        let days = (endDate - startDate) / (1 * 24 * 60 * 60 * 1000);
        return days;
    }

    static getPreviousQuarterEndMonth(year, month) {
        let quarterEndMonth = 0;
        if (month <= 3) {
            quarterEndMonth = 12;
            year = year - 1;
        }
        if (3 < month && month <= 6) {
            quarterEndMonth = 3;
        }
        if (6 < month && month <= 9) {
            quarterEndMonth = 6;
        }
        if (month > 9) {
            quarterEndMonth = 9;
        }
        return year + '-' + quarterEndMonth.toString().padStart(2, 0) + '-01';
    }

    static getMonthsBetween(dateString1, dateString2) {
        let date1 = new Date(dateString1);
        let date2 = new Date(dateString2);
        date1 = parseInt(date1.getFullYear()) * 12 + (parseInt(date1.getMonth()) + 1);
        date2 = parseInt(date2.getFullYear()) * 12 + (parseInt(date2.getMonth()) + 1);
        return Math.abs(date1 - date2);
    }

    static getNowYearMonthDay() {
        let now = formatDate(new Date(), 'yyyy-MM-dd');
        let year = Number.parseInt(now.split('-')[0]);
        let month = Number.parseInt(now.split('-')[1]);
        let day = Number.parseInt(now.split('-')[2]);
        return {year, month, day};
    }

    //当日间隔天数计算
    static getIntervalDate(intervalNum, separator = '-') {
        let now = new Date();
        now.setDate(now.getDate() + intervalNum);
        let year = now.getFullYear().toString();
        let month = (now.getMonth() + 1).toString().padStart(2, '0');
        let day = (now.getDate()).toString().padStart(2, '0');
        return [year, month, day].join(separator);
    }

    /** 获取指定日期的前后月份的时间
     * @param date
     * @param monthNum
     */
    static getIntervalMonth(date, monthNum) {
        date.setMonth(date.getMonth() + monthNum);
        return formatDate(date, 'yyyy-MM-dd');
    }

    //两个时间的间隔：天、时、分、秒
    static getIntervalTime(startDate, endDate) {
        // 时间相差秒数
        let dateDiff = endDate.getTime() - startDate.getTime();
        // 计算出相差天数
        let days = Math.floor(dateDiff / (24 * 3600 * 1000));
        // 计算出小时数
        let residue1 = dateDiff % (24 * 3600 * 1000); // 计算天数后剩余的毫秒数
        let hours = Math.floor(residue1 / (3600 * 1000));
        // 计算相差分钟数
        let residue2 = residue1 % (3600 * 1000); // 计算小时数后剩余的毫秒数
        let minutes = Math.floor(residue2 / (60 * 1000));
        // 计算相差秒数
        let residue3 = residue2 % (60 * 1000); // 计算分钟数后剩余的毫秒数
        let seconds = Math.round(residue3 / 1000);
        return [days, hours, minutes, seconds];
    }

    static showLocale(date) {
        let str, colorhead, colorfoot;
        let yy = date.getYear();
        if (yy < 1900) yy = yy + 1900;
        let MM = date.getMonth() + 1;
        if (MM < 10) MM = '0' + MM;
        let dd = date.getDate();
        if (dd < 10) dd = '0' + dd;
        let hh = date.getHours();
        if (hh < 10) hh = '0' + hh;
        let mm = date.getMinutes();
        if (mm < 10) mm = '0' + mm;
        let ss = date.getSeconds();
        if (ss < 10) ss = '0' + ss;
        let ww = date.getDay();
        if (ww == 0) colorhead = "<font color=\"#bcc2e1\">";
        if (ww > 0 && ww < 6) colorhead = "<font color=\"#bcc2e1\">";
        if (ww == 6) colorhead = "<font color=\"#bcc2e1\">";
        if (ww == 0) ww = "星期日";
        if (ww == 1) ww = "星期一";
        if (ww == 2) ww = "星期二";
        if (ww == 3) ww = "星期三";
        if (ww == 4) ww = "星期四";
        if (ww == 5) ww = "星期五";
        if (ww == 6) ww = "星期六";
        colorfoot = "</font>"
        str = colorhead + yy + "年" + MM + "月" + dd + "日" + " " + ww + " " + hh + ":" + mm + ":" + ss + "  " + colorfoot;
        return (str);
    }

    //时间按秒加减
    static addSeconds(dateTime, n) {
        dateTime.setSeconds(dateTime.getSeconds() + n);
        return dateTime;
    }

}
